export default __webpack_public_path__ + "static/media/330_business02-en-mobile.c4a2ac81.png";